import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { MenuSection } from "./components/MenuSection";
import { OrderSection } from "./components/OrderSection";
import { Gallery } from "./components/Gallery";
import { LocationHours } from "./components/LocationHours";
import { InstagramSection } from "./components/InstagramSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <MenuSection />
        <OrderSection />
        <Gallery />
        <LocationHours />
        <InstagramSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
